import {useEffect, useRef, useState} from "react";
import {
    COUNTRY_SCOPE_STORAGE_KEY,
    getAdminCountryScope,
    resolveAdminCountryScope,
} from "../../shared/api/countryScope";
import {getActorCountryScopeBlock} from "../../shared/finance/actorCountryScope";

export const useSplitCountryScope = (capabilities) => {
    const [countryScope, setCountryScope] = useState(() =>
        resolveAdminCountryScope({
            role: capabilities.user?.role,
            allowedCountryIds: capabilities.scope?.country_ids || [],
            storedScope:
                localStorage.getItem(COUNTRY_SCOPE_STORAGE_KEY) ?? getAdminCountryScope(),
        }),
    );
    const activeCountryScopeRef = useRef(countryScope);

    useEffect(() => {
        const handleCountryChange = (event) => {
            const nextScope = event.detail?.countryId;
            const normalizedScope = nextScope == null ? null : String(nextScope);
            activeCountryScopeRef.current = normalizedScope;
            setCountryScope(normalizedScope);
        };
        window.addEventListener("sorpa-admin-country-scope-change", handleCountryChange);
        return () =>
            window.removeEventListener("sorpa-admin-country-scope-change", handleCountryChange);
    }, []);

    return {
        countryScope,
        activeCountryScopeRef,
        scopeBlock: getActorCountryScopeBlock({
            countryScope,
            actorCountryId: capabilities.country?.id,
        }),
    };
};
